import React from "react"
import { SearchOutlined } from "@ant-design/icons"
import { Form, Input } from "antd"
import { Button } from "src/components/actions/button"
import { RotateClockwiseSvg } from "src/components/Svg"
import styled from "styled-components"

/**
 * Единый блок поиска над таблицей: инпут + «Искать» + «Сбросить».
 * `handleSearch` получает строку-значение (пустую при сбросе).
 * `placeholder` подсвечивает поля, по которым идёт поиск (id / название / uuid и т.п.).
 */
export function TableSearch({ handleSearch, placeholder = "Поиск", maxLength = 200 }) {
  const [form] = Form.useForm()

  function onFinish(values) {
    handleSearch((values.search ?? "").trim())
  }

  function onClear() {
    form.resetFields()
    handleSearch("")
  }

  return (
    <SearchForm form={form} layout="vertical" onFinish={onFinish}>
      <SearchItem name="search">
        <Input placeholder={placeholder} maxLength={maxLength} allowClear />
      </SearchItem>
      <Button danger onClick={onClear} icon={<RotateClockwiseSvg />}>
        Сбросить
      </Button>
      <Button icon={<SearchOutlined />} type="primary" htmlType="submit">
        Искать
      </Button>
    </SearchForm>
  )
}

const SearchForm = styled(Form)`
  display: flex;
  align-items: center;
  gap: 20px;
  margin: 20px 0;
`

const SearchItem = styled(Form.Item)`
  margin: 0;
  flex: 1 1 320px;
  max-width: 520px;
`
